import React, { useEffect, useRef } from 'react'
import 'quill-mention'
import ReactQuill from 'react-quill'
import { getMentionModuleConfig } from '../helpers/Util'

const Editor = ({
    setReadOnly,
    callBack,
    mention,
    memberList,
    readOnly,
    value,
    styleList = []
}) => {
    const reactQuillRef = useRef()

    useEffect(() => {
        if (!readOnly) {
            reactQuillRef.current.focus()
        }
    }, [readOnly])

    return (
        <div className='w-full relative' onClick={() => setReadOnly(false)}>
            <ReactQuill
                ref={reactQuillRef}
                readOnly={readOnly}
                value={value}
                selection={{ start: 0, end: 0 }}
                name='post'
                debug='info'
                theme='bubble'
                onChange={(value) => callBack(value)}
                placeholder={
                    styleList?.length > 0
                        ? 'Write comment or use @ to mention users or # to mention styles'
                        : 'Write comment or use @ to mention users'
                }
                modules={{
                    mention: !mention
                        ? null
                        : getMentionModuleConfig(
                              memberList,
                              styleList,
                              readOnly
                          )
                }}
                preserveWhitespace={true}
                className='custom-scroll h-[70px] w-[90%]'
            />
        </div>
    )
}

export default Editor
